import produce from 'immer';
import {
  GET_AFFILIATES_BANNER_SLIDES_START,
  GET_AFFILIATES_BANNER_SLIDES_SUCCESS,
  GET_AFFILIATES_BANNER_SLIDES_FAILED,
  ADD_AFFILIATES_BANNER_SLIDE_START,
  ADD_AFFILIATES_BANNER_SLIDE_SUCCESS,
  ADD_AFFILIATES_BANNER_SLIDE_FAILED,
  DELETE_AFFILIATES_BANNER_SLIDE_START,
  DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS,
  DELETE_AFFILIATES_BANNER_SLIDE_FAILED,
  EDIT_AFFILIATES_BANNER_SLIDE_START,
  EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS,
  EDIT_AFFILIATES_BANNER_SLIDE_FAILED,
  GET_FULLFILMENT_BANNER_SLIDES_START,
  GET_FULLFILMENT_BANNER_SLIDES_SUCCESS,
  GET_FULLFILMENT_BANNER_SLIDES_FAILED,
  ADD_FULLFILMENT_BANNER_SLIDE_START,
  ADD_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  ADD_FULLFILMENT_BANNER_SLIDE_FAILED,
  DELETE_FULLFILMENT_BANNER_SLIDE_START,
  DELETE_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  DELETE_FULLFILMENT_BANNER_SLIDE_FAILED,
  EDIT_FULLFILMENT_BANNER_SLIDE_START,
  EDIT_FULLFILMENT_BANNER_SLIDE_SUCCESS,
  EDIT_FULLFILMENT_BANNER_SLIDE_FAILED,
  GET_AFFILIATE_PROVIDERS_START,
  GET_AFFILIATE_PROVIDERS_SUCCESS,
  GET_AFFILIATE_PROVIDERS_FAILED,
  GET_STORE_AFFILIATES_START,
  GET_STORE_AFFILIATES_SUCCESS,
  GET_STORE_AFFILIATES_FAILED,
  ADD_AFFILIATE_TO_STORE_START,
  ADD_AFFILIATE_TO_STORE_SUCCESS,
  ADD_AFFILIATE_TO_STORE_FAILED,
  SEND_REQUEST_PRODUCTS_EMAIL_START,
  SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS,
  SEND_REQUEST_PRODUCTS_EMAIL_FAILED,
} from '../actions/partners';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  affiliatesSlides: [],
  loadingAffiliatesSlides: false,
  fullfilmentSlides: [],
  loadingFullfilmentSlides: false,
  affiliateProviders: [],
  affiliateProvidersKeywords: [],
  loadingAffiliateProviders: false,
  storeAffiliates: [],
  loadingStoreAffiliates: false,
  loadingFullfilmentRequest: false,
};

const formReducer = produce((state: IPartnersState = initialState, action) => {
  switch (action.type) {
    case GET_AFFILIATES_BANNER_SLIDES_START: {
      state.loadingAffiliatesSlides = true;
      break;
    }
    case GET_AFFILIATES_BANNER_SLIDES_SUCCESS: {
      const {data} = action;

      state.affiliatesSlides = data.banners;
      state.loadingAffiliatesSlides = false;
      break;
    }
    case GET_AFFILIATES_BANNER_SLIDES_FAILED: {
      state.loadingAffiliatesSlides = false;
      break;
    }

    case ADD_AFFILIATES_BANNER_SLIDE_START: {
      state.loadingAffiliatesSlides = true;
      break;
    }
    case ADD_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      const {data} = action;

      state.affiliatesSlides = [...state.affiliatesSlides, data.banner];
      state.loadingAffiliatesSlides = false;
      break;
    }
    case ADD_AFFILIATES_BANNER_SLIDE_FAILED: {
      state.loadingAffiliatesSlides = false;
      break;
    }

    case DELETE_AFFILIATES_BANNER_SLIDE_START: {
      state.loadingAffiliatesSlides = true;
      break;
    }
    case DELETE_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      const {id} = action;

      state.affiliatesSlides = state.affiliatesSlides.filter((slide) => slide._id !== id);
      state.loadingAffiliatesSlides = false;
      break;
    }
    case DELETE_AFFILIATES_BANNER_SLIDE_FAILED: {
      state.loadingAffiliatesSlides = false;
      break;
    }

    case EDIT_AFFILIATES_BANNER_SLIDE_START: {
      state.loadingAffiliatesSlides = true;
      break;
    }
    case EDIT_AFFILIATES_BANNER_SLIDE_SUCCESS: {
      const {data, id} = action;

      state.affiliatesSlides = state.affiliatesSlides.map((slide) => slide._id == id ? data.banner : slide);
      state.loadingAffiliatesSlides = false;
      break;
    }
    case EDIT_AFFILIATES_BANNER_SLIDE_FAILED: {
      state.loadingAffiliatesSlides = false;
      break;
    }


    case GET_FULLFILMENT_BANNER_SLIDES_START: {
      state.loadingFullfilmentSlides = true;
      break;
    }
    case GET_FULLFILMENT_BANNER_SLIDES_SUCCESS: {
      const {data} = action;

      state.fullfilmentSlides = data.banners;
      state.loadingFullfilmentSlides = false;
      break;
    }
    case GET_FULLFILMENT_BANNER_SLIDES_FAILED: {
      state.loadingFullfilmentSlides = false;
      break;
    }

    case ADD_FULLFILMENT_BANNER_SLIDE_START: {
      state.loadingFullfilmentSlides = true;
      break;
    }
    case ADD_FULLFILMENT_BANNER_SLIDE_SUCCESS: {
      const {data} = action;

      state.fullfilmentSlides = [...state.fullfilmentSlides, data.banner];
      state.loadingFullfilmentSlides = false;
      break;
    }
    case ADD_FULLFILMENT_BANNER_SLIDE_FAILED: {
      state.loadingFullfilmentSlides = false;
      break;
    }

    case DELETE_FULLFILMENT_BANNER_SLIDE_START: {
      state.loadingFullfilmentSlides = true;
      break;
    }
    case DELETE_FULLFILMENT_BANNER_SLIDE_SUCCESS: {
      const {id} = action;

      state.fullfilmentSlides = state.fullfilmentSlides.filter((slide) => slide._id !== id);
      state.loadingFullfilmentSlides = false;
      break;
    }
    case DELETE_FULLFILMENT_BANNER_SLIDE_FAILED: {
      state.loadingFullfilmentSlides = false;
      break;
    }

    case EDIT_FULLFILMENT_BANNER_SLIDE_START: {
      state.loadingFullfilmentSlides = true;
      break;
    }
    case EDIT_FULLFILMENT_BANNER_SLIDE_SUCCESS: {
      const {data, id} = action;

      state.fullfilmentSlides = state.fullfilmentSlides.map((slide) => slide._id == id ? data.banner : slide);
      state.loadingFullfilmentSlides = false;
      break;
    }
    case EDIT_FULLFILMENT_BANNER_SLIDE_FAILED: {
      state.loadingFullfilmentSlides = false;
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.affiliatesSlides = [];

      break;
    }

    case GET_AFFILIATE_PROVIDERS_START: {
      state.loadingAffiliateProviders = true;
      break;
    }
    case GET_AFFILIATE_PROVIDERS_SUCCESS: {
      const {data} = action;
      state.affiliateProviders = data;
      const keywords = data.reduce((acc, a) => {
        const filtered = a.keywords.filter((key) => !acc.includes(key));
        acc = [...acc, ...filtered];
        return acc;
      }, []);
      state.affiliateProvidersKeywords = keywords;
      state.loadingAffiliateProviders = false;
      break;
    }
    case GET_AFFILIATE_PROVIDERS_FAILED: {
      state.loadingAffiliateProviders = false;
      break;
    }

    case GET_STORE_AFFILIATES_START: {
      state.loadingStoreAffiliates = true;
      break;
    }
    case GET_STORE_AFFILIATES_SUCCESS: {
      state.storeAffiliates = action.data;
      state.loadingStoreAffiliates = false;
      break;
    }
    case GET_STORE_AFFILIATES_FAILED: {
      state.loadingStoreAffiliates = false;
      break;
    }

    case ADD_AFFILIATE_TO_STORE_START: {
      state.loadingStoreAffiliates = true;
      break;
    }
    case ADD_AFFILIATE_TO_STORE_SUCCESS: {
      const {data} = action.data;
      state.storeAffiliates = [...state.storeAffiliates, data];
      state.loadingStoreAffiliates = false;
      break;
    }
    case ADD_AFFILIATE_TO_STORE_FAILED: {
      state.loadingStoreAffiliates = false;
      break;
    }
    case SEND_REQUEST_PRODUCTS_EMAIL_START: {
      state.loadingFullfilmentRequest = true;
      break;
    }
    case SEND_REQUEST_PRODUCTS_EMAIL_SUCCESS: {
      state.loadingFullfilmentRequest = false;
      break;
    }
    case SEND_REQUEST_PRODUCTS_EMAIL_FAILED: {
      state.loadingFullfilmentRequest = false;
      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
